import { Link } from "react-router-dom";
import { type Site } from "../api";
import {
  MKCard,
  MKCardHeader,
  MKCardTitle,
  MKCardContent,
  MKButton,
  MKBadge,
  MKTable,
  MKTableHeader,
  MKTableBody,
  MKTableHead,
  MKTableRow,
  MKTableCell,
} from "@mytraai/mytrakit";

interface Props {
  sites: Site[];
  selectedId?: number;
  onAddSite: () => void;
}

export default function SiteSelector({ sites, selectedId, onAddSite }: Props) {
  return (
    <MKCard>
      <MKCardHeader className="pb-2">
        <div className="flex items-center justify-between">
          <MKCardTitle className="text-base">Sites</MKCardTitle>
          <MKButton variant="secondary" size="sm" onClick={onAddSite}>
            New Site
          </MKButton>
        </div>
      </MKCardHeader>
      <MKCardContent className="p-0">
        {sites.length === 0 ? (
          <p className="text-content-tertiary p-4">No sites configured</p>
        ) : (
          <MKTable>
            <MKTableHeader>
              <MKTableRow>
                <MKTableHead>Name</MKTableHead>
                <MKTableHead>Type</MKTableHead>
                <MKTableHead>Scan Status</MKTableHead>
                <MKTableHead className="text-right">Created</MKTableHead>
              </MKTableRow>
            </MKTableHeader>
            <MKTableBody>
              {sites.map((site) => (
                <MKTableRow
                  key={site.site_id}
                  className={
                    selectedId === site.site_id ? "bg-surface-brand/10" : ""
                  }
                >
                  <MKTableCell className="font-medium">
                    <Link
                      to={`/site/${site.site_id}`}
                      className="text-content-primary hover:text-content-secondary"
                    >
                      {site.name}
                    </Link>
                  </MKTableCell>
                  <MKTableCell>
                    {site.is_production ? (
                      <MKBadge variant="destructive" size="sm">
                        PROD
                      </MKBadge>
                    ) : (
                      <MKBadge variant="secondary" size="sm">
                        DEV
                      </MKBadge>
                    )}
                  </MKTableCell>
                  <MKTableCell className="text-content-destructive text-sm">
                    {site.scan_errors || ""}
                  </MKTableCell>
                  <MKTableCell className="text-right text-content-tertiary">
                    {new Date(site.created_at).toLocaleDateString()}
                  </MKTableCell>
                </MKTableRow>
              ))}
            </MKTableBody>
          </MKTable>
        )}
      </MKCardContent>
    </MKCard>
  );
}
